import ClauseSectionType from '../actions/types/ClauseSectionType';
import { InboxRulesEditOptionState } from '../store/schema/InboxRulesEditOptionState';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';

export interface RemoveClauseState {
    optionState: InboxRulesEditOptionState;
}

/**
 * Removes a clause from the rules edit page
 * @param clauseId the id of the clause to remove
 * @param sectionType the section that the clause belongs to (action, conditional, exception)
 */
export default select<RemoveClauseState>({
    optionState: () => store.inboxRulesEditState,
})(
    action('removeClause')(function removeClause(
        clauseId: string,
        sectionType: ClauseSectionType,
        state?: RemoveClauseState
    ) {
        let { optionState } = state;
        optionState.clauseMap.delete(clauseId);

        if (sectionType == 'conditional') {
            let indexToDelete = optionState.conditionalClauseIds.indexOf(clauseId);
            optionState.conditionalClauseIds.splice(indexToDelete, 1);
        } else if (sectionType == 'action') {
            let indexToDelete = optionState.actionClauseIds.indexOf(clauseId);
            optionState.actionClauseIds.splice(indexToDelete, 1);
        } else if (sectionType == 'exception') {
            let indexToDelete = optionState.exceptionClauseIds.indexOf(clauseId);
            optionState.exceptionClauseIds.splice(indexToDelete, 1);
        } else {
            throw new Error('Cannot remove clause in section type that does not exist');
        }
    })
);
